import { $$ } from '../utils/dom.js';
import { Swiper } from '../vendor/vendor-globals.js';

const SLIDE_SPEED = 1200;

export function initMenuSlider() {
  const disposers = $$('[data-component="menu-slider"]').map((root) => setupMenuSlider(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setupMenuSlider(root) {
  if (typeof Swiper !== 'function') {
    return () => {};
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const realSlideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
  let fixingLoop = false;

  const syncFeatured = (realIndex) => {
    const featuredIndex = (realIndex + 1) % realSlideCount;

    root.querySelectorAll('.swiper-slide').forEach((slide) => {
      const index = Number(slide.getAttribute('data-swiper-slide-index'));
      slide.classList.toggle('is-featured', index === featuredIndex);
    });
  };

  const alignToLayout = (instance) => {
    const slides = instance.slides;
    const grid = [];

    for (let index = 0; index < slides.length; index += 1) {
      grid.push(slides[index].offsetLeft);
    }

    instance.slidesGrid = grid;
    instance.snapGrid = grid.slice();
    instance.setTransition(0);
    instance.setTranslate(-slides[instance.activeIndex].offsetLeft);
  };

  // Read the translate target after featured widths are applied, then restart
  // the width transition from the previous layout so it stays in step with the slide.
  const measureFinalTranslate = (instance) => {
    const slides = Array.from(instance.slides);
    const featuredBefore = slides.map((slide) => slide.classList.contains('is-featured'));
    const activeSlide = slides[instance.activeIndex];

    root.classList.add('is-loop-fix');
    syncFeatured(instance.realIndex);
    const target = activeSlide ? -activeSlide.offsetLeft : instance.getTranslate();

    slides.forEach((slide, index) => {
      slide.classList.toggle('is-featured', featuredBefore[index]);
    });
    void root.offsetWidth;
    root.classList.remove('is-loop-fix');
    void root.offsetWidth;
    syncFeatured(instance.realIndex);

    return target;
  };

  const swiper = new Swiper(root, {
    slidesPerView: 'auto',
    initialSlide: 0,
    speed: reduceMotion ? 0 : SLIDE_SPEED,
    loop: true,
    loopedSlides: realSlideCount,
    loopedSlidesLimit: false,
    allowTouchMove: false,
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 12,
      },
    },
    on: {
      init(instance) {
        root.classList.add('is-loop-fix');
        syncFeatured(instance.realIndex);
        void root.offsetWidth;
        alignToLayout(instance);
        root.classList.remove('is-loop-fix');
      },
      slideChangeTransitionStart(instance) {
        if (!instance.initialized || fixingLoop) {
          return;
        }

        if (instance.params.speed === 0) {
          root.classList.add('is-loop-fix');
          syncFeatured(instance.realIndex);
          void root.offsetWidth;
          alignToLayout(instance);
          root.classList.remove('is-loop-fix');
          return;
        }

        const target = measureFinalTranslate(instance);
        instance.setTransition(instance.params.speed);
        instance.setTranslate(target);
      },
      beforeLoopFix(instance) {
        fixingLoop = true;
        root.classList.add('is-loop-fix');
        void root.offsetWidth;
        alignToLayout(instance);
      },
      loopFix(instance) {
        alignToLayout(instance);
        fixingLoop = false;
        root.classList.remove('is-loop-fix');
      },
      resize(instance) {
        if (!instance.initialized) {
          return;
        }

        root.classList.add('is-loop-fix');
        syncFeatured(instance.realIndex);
        void root.offsetWidth;
        alignToLayout(instance);
        root.classList.remove('is-loop-fix');
      },
    },
  });

  return () => {
    swiper.destroy(true, true);
  };
}
